module.exports = __webpack_public_path__ + "static/media/khuzam_headshot.2950189e.png";